// extracted by mini-css-extract-plugin
export default {"header":"L30vXyzb9kYYyo4RlbDd"};